import * as React from 'react';
import {Redirect, RouteComponentProps, withRouter} from 'react-router-dom'
import {withTranslation, WithTranslation} from 'react-i18next'

interface AdminPageLayoutProps extends RouteComponentProps, WithTranslation {

}

interface AdminPageLayoutState {

}

class Admin extends React.Component<AdminPageLayoutProps, AdminPageLayoutState> {
    
    constructor(props: AdminPageLayoutProps) {
        super(props);

        this.state = {

        }
    }

    componentDidMount() { }

    public render() {
        return <Redirect to='/time-tracking/admin/companies' />
    }
}
export default withTranslation()(withRouter(Admin) as any)
